import { Component } from 'react';
import { Card, Col, Container, Dropdown, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { actions } from 'forms/rrf';
import { isNull } from 'lodash';
import { getMyStoresListRep as getOutlets } from '../../../../actions/outlet';
import { history } from '../../../../store';
import OutletSearch from '../../../admin/outlet-list/outlet-search';
import { doPseudoLoginRep } from '../../../../actions/users';
import MessageDialog from '../message-dialog';
import { sendStoreMessage } from '../../../../actions/messages';
import { checkPermission } from '../../../common/guards/can';
import { isPseudoLoggedIn } from '../../../../utils/tokenUtils';
import PageTitle from '../../../common/page-title/index';
import withPaginatedFilter from '../../../common/withPaginatedFilter';
import RepOutletTable from './rep-outlet-table';

import './list.css';

class MyStoresListView extends Component {
  state = {
    showMessageDialog: false,
    outlet: undefined,
    outletName: '',
    ownerName: '',
  };

  openMessageModal = (outlet, outletName, ownerName) => {
    try {
      this.setState({
        showMessageDialog: true,
        outlet,
        outletName,
        ownerName,
      }, () => {
        this.props.dispatch(actions.reset('deep.store_message'));
      });
    } catch (error) { //
      // swallowed modal lib bug error
    }
  };

  renderOutletActions = ({
    id, outlet_name: outletName, owner_name: ownerName, owner_id: ownerId,
    owner_status: ownerStatus, owner_locked: ownerLocked
  }, ...props) => (
    <div {...props}>
      <Dropdown>
        <Dropdown.Toggle variant="default" className="red-ghost-btn">
          Actions
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item eventKey="1" onClick={() => history.push(`/team/outlets/${id}`)}>
            View Store
          </Dropdown.Item>
          {checkPermission('view', 'points_rep_area') && ownerName && (
          <Dropdown.Item
            eventKey="2"
            onClick={() => history.push(`/team/outlets/${id}/points-activity`)}
          >
            Points Statement
          </Dropdown.Item>
        )}
          {checkPermission('view', 'messages_rep_area') && ownerName && (
          <Dropdown.Item eventKey="3" onClick={() => this.openMessageModal(id, outletName, ownerName)}>
            Send Message
          </Dropdown.Item>
        )}
          {checkPermission('pseudo-login-read', 'web_app') && ownerName && !isPseudoLoggedIn()
            && !['disabled', 'pending', 'invited', 'expired'].includes(ownerStatus) && !ownerLocked && (
            <Dropdown.Item eventKey="4" disabled={isNull(ownerName)} onClick={() => this.handleStoreDemoClick(ownerId)}>
              Store Demo
            </Dropdown.Item>
        )}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );

  handleStoreDemoClick = (userId) => {
    doPseudoLoginRep(userId);
  };

  handleMessageClose = () => {
    this.setState({
      showMessageDialog: false,
      outlet: undefined,
    });
  };

  handleMessageSend = (payload) => {
    const {dispatch} = this.props;
    const {outlet} = this.state;

    const message = {
      ...payload,
      outlet_id: outlet,
    };

    dispatch(sendStoreMessage(message))
      .then(() => {
        dispatch(actions.reset('deep.store_message'));
        this.handleMessageClose();
      });
  };

  render() {
    const {
      isLoading, outlets, paging, pageNumber, query,
      handleChange, handleClear, handleSearch, handlePageChange
    } = this.props;
    const {
      showMessageDialog, ownerName, outletName, outlet: outletId
    } = this.state;
    const outletsWithActions = outlets.map((outlet, key) => ({
      ...outlet,
      attributes: {
        ...outlet.attributes,
        actions: this.renderOutletActions({
          key,
          owner_name: outlet.attributes.owner,
          outlet_name: outlet.attributes.name,
          id: outlet.id,
          owner_id: outlet.attributes['owner-id'],
          owner_status: outlet.attributes['owner-status'],
          owner_locked: outlet.attributes['owner-locked']
        })
      }
    }));

    return (
      <Container className='rep-store-list'>
        <Row>
          <Col lg={12}>
            <PageTitle>
              My stores
            </PageTitle>
          </Col>
        </Row>
        <OutletSearch
          onChange={handleChange}
          onClear={handleClear}
          onSearch={handleSearch}
          searchValue={query}
          placeholder="Customer unique number, outlet name, postcode, group name"
        />
        <Row>
          <Col lg={12}>
            <Card className="my-stores-list">
              <Card.Body>
                {isLoading ? 'Loading...' : (
                  <RepOutletTable
                    outlets={outletsWithActions}
                    currentPage={pageNumber}
                    onPageChange={handlePageChange}
                    paging={paging}
                  />
              )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {showMessageDialog && (
          <MessageDialog
            onClose={this.handleMessageClose}
            onMessageSend={payLoad => this.handleMessageSend(payLoad)}
            to={`${ownerName}-${outletName}-${outletId}`}
          />
        )}
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  outlets: state.stores.repOutlets,
  isLoading: state.stores.fetching && !state.stores.fetched,
  paging: state.stores.repPaging,
});

export default connect(mapStateToProps)(withPaginatedFilter(MyStoresListView, getOutlets));

